module.exports = __webpack_public_path__ + "static/media/negative-gameweek-player.20645543.png";